import React, { useState } from "react";
import Check from "../../assets/icons/check.svg";
import { Link } from "react-router-dom";
import { Input as InputField, message, Form } from "antd";
import Button from "../../components/common/button";
import { colors } from "../../share/constants/enums";
import { inviteMember } from "../../api/invite";
import PhoneInput from "../common/handlePhoneInput";

const InvitePage = () => {
  const businessId = localStorage.getItem("businessId");

  const [show, setShow] = useState(false);
  const [loader, setLoader] = useState(false);
  const [value, setValue] = useState({
    businessId: businessId,
    email: "",
    firstName: "",
    lastName: "",
    phoneNumber: "",
  });

  const handleOnChange = (e) => {
    setValue({
      ...value,
      [e.target.name]: e.target.value,
    });
  };

  const onHandleSubmit = async () => {
    setLoader(true);
    try {
      const res = await inviteMember(value);
      if (res) {
        setShow(true);
        setValue({
          businessId: businessId,
          email: "",
          firstName: "",
          lastName: "",
          phoneNumber: "",
        });
        setTimeout(() => {
          setShow(false);
        }, 2000);
      }
    } catch (error) {
      message.error(error);
    } finally {
      setLoader(false);
    }
  };

  return (
    <div className="flex flex-col items-center mt-2 md:mt-0 md:justify-center lg:col-span-2 lg:mt-0 lg:p-3">
      <div className="flex flex-col items-center xl:flex xl:flex-col xl:justify-center xl:items-center xl:mt-5">
        {show ? (
          <div className="mt-5 xl:mt-0">
            <img className="w-12 h-2.5" alt="yupup-logo" src={Check} />
          </div>
        ) : (
          ""
        )}
        <Form>
          <div className="space-y-2 mt-5 xl:flex xl:flex-col xl:items-center xl:space-y-3 xl:mt-5">
            <div className="flex flex-col space-y-2 lg:grid lg:grid-cols-2 lg:gap-2 lg:space-y-0 ">
              <InputField
                className={
                  "w-31 hover:border-primaryBlue h-5.4  rounded sm:w-31 md:w-40 lg:w-full "
                }
                name="firstName"
                placeholder="First Name"
                value={value.firstName}
                onChange={(e) => handleOnChange(e)}
              />
              <InputField
                className={
                  "w-31 hover:border-primaryBlue h-5.4  rounded sm:w-31 md:w-40 lg:w-full "
                }
                name="lastName"
                placeholder="Last Name"
                value={value.lastName}
                onChange={(e) => handleOnChange(e)}
              />
            </div>
            <div className="lg:w-full">
              <InputField
                className={
                  "w-31 hover:border-primaryBlue h-5.4 rounded md:w-full lg:w-full"
                }
                placeholder="Email"
                name="email"
                value={value.email}
                onChange={(e) => handleOnChange(e)}
              />
            </div>
            <div className="lg:w-full">
              <Form.Item
                rules={[
                  {
                    required: true,
                    message: "Please Enter Correct Phone Number",
                    pattern: /^\+1 \(\d{3}\) \d{3}-\d{4}$/,
                  },
                ]}
              >
                <PhoneInput
                  name="phoneNumber"
                  value={value.phoneNumber}
                  onChange={(e) => handleOnChange(e)}
                />
              </Form.Item>
            </div>
            <div className="lg:w-full">
              <Link className="no-underline">
                <Button
                  loading={loader}
                  onClick={onHandleSubmit}
                  title="Send Invitation"
                  color={colors.primaryPurple}
                  className="w-31 md:w-full lg:w-full"
                />
              </Link>
            </div>
            <div className="lg:w-full">
              <Link to="/deal" className="no-underline">
                <Button
                  title="Skip For Now"
                  color={colors.white}
                  border={colors.primaryPurple}
                  className="w-31 md:w-full lg:w-full text-primaryPurple"
                />
              </Link>
            </div>
          </div>
        </Form>
      </div>
      <div className="mt-2 lg:w-full lg:flex lg:justify-end">
        <Link to="/deal" className="no-underline">
          <Button
            title="Finish"
            color={colors.primaryPurple}
            className="w-19"
          />
        </Link>
      </div>
    </div>
  );
};

export default InvitePage;
